import { Pressable, Text, View } from 'react-native'
import { colors } from '@/src/theme'
import { body4 } from '@/src/theme/typography'

export interface VoiceAssessmentStatisticSegmentOption<T extends string> {
  key: T
  label: string
}

interface VoiceAssessmentStatisticSegmentedControlProps<T extends string> {
  value: T
  onChange: (next: T) => void
  options: VoiceAssessmentStatisticSegmentOption<T>[]
}

export function VoiceAssessmentStatisticSegmentedControl<T extends string>({
  value,
  onChange,
  options,
}: VoiceAssessmentStatisticSegmentedControlProps<T>) {
  return (
    <View className="h-8 flex-row overflow-hidden rounded-full bg-fill-input">
      {options.map((option, index) => {
        const active = value === option.key
        const showDivider = index < options.length - 1
        return (
          <Pressable
            key={option.key}
            onPress={() => {
              onChange(option.key)
            }}
            className={`h-full flex-1 items-center justify-center px-2.5 py-0.5 active:opacity-90 ${active ? 'bg-primary' : ''} ${showDivider ? 'border-r border-border' : ''}`}
          >
            <Text
              style={[
                body4,
                active
                  ? { color: colors.primaryForeground }
                  : { color: colors.textBody },
              ]}
            >
              {option.label}
            </Text>
          </Pressable>
        )
      })}
    </View>
  )
}
